module.exports = __webpack_public_path__ + "img/share-facebook.a74cc118.svg";